import { constants } from './../utitlity/constant';
import { Helper } from './../utitlity/helper';
import { Router } from '@angular/router';
import {  AuthenticationService } from './authentication.service';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgZone } from '@angular/core';
import { of } from 'rxjs/observable/of';
@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
    unauthStatuses = [401, 403];
    constructor(private router: Router, private _authservice : AuthenticationService,
        public zone: NgZone) { }



    clearStorage() {
        try {
            sessionStorage.removeItem('psId');
        } catch (e) {
        }
    }

    // intercept(request: HttpRequest<any>, next: any): Observable<any> {        
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log(request.url, 'request.url');

        if ((request.url.indexOf('iupload')) === -1 && (request.url.indexOf('decrypt')) === -1) {

            request = request.clone({
                setHeaders: {
                    'X-HSBC-Locale': 'en_GB',
                    'X-HSBC-Chnl-CountryCode': 'AE',
                    'X-HSBC-Chnl-Group-Member': 'HBEU',
                    'X-HSBC-Channel-Id': 'OHI',
                    'Content-Type': 'application/json',
                    'No-Auth': 'True'
                    // 'X-HSBC-Saml':'<saml:Assertion xmlns:saml="http://www.hsbc.com/saas/assertion"><Signature><KeyAlias>E2E_TRUST_SAAS_NA01_DIT4_ALIAS</KeyAlias><SignatureValue>HHKXEt+GHtqSm46/Iq0sJx+nEpqgv5A+OVmjc57j/JTM1jtDtGDBNdE9EQwAo8Zye0YXSE0A2qNtE0EBneuxGFzCsTY/qbPnTMca9JzaNFFvKhxAJqTSKwQ+5Z5F1orzugaDpqfYITAyX8AEmxeulFu1DffyG8ecixPIePbDiL0rC0hi5pvWv1zwryYdaK/QzUkSQvpKntJlpt4XSnG7DGgksFw6LdoCxOHUOxH2LIqfmR+flGva1CwB7ulwMDDzj8tZtBoin1r58ADx4D0rUU1y6/nlLDR+S2O4DxZNiJzFfo8cxdOxYmNV2Z616RuqI1BO5RAHgnS/mU+lopSNxQ==</SignatureValue></Signature><saml:Subject><saml:NameID>IB1ib5793467</saml:NameID></saml:Subject><saml:Conditions NotBefore="2015-12-08T17:32:06.583Z" NotOnOrAfter="2015-12-08T17:33:06.583Z" ></saml:Conditions><saml:AttributeStatement><saml:Attribute Name="IP"><saml:AttributeValue>130.47.61.229</saml:AttributeValue></saml:Attribute><saml:Attribute Name="CAM"><saml:AttributeValue>30</saml:AttributeValue></saml:Attribute></saml:AttributeStatement></saml:Assertion>
                }
            });
        } 
        else {
            request = request.clone(
                {
                    
                    setHeaders: {
                        'X-HSBC-Locale': 'en_GB',
                        'No-Auth': 'True',
                        'X-HSBC-Chnl-CountryCode': 'AE',
                        'X-HSBC-Chnl-Group-Member': 'BBME',
                        'X-HSBC-User-Id': 'OHI',
                        'X-HSBC-CAM-Level': '',
                        'X-HSBC-Channel-Id': '',
                        'X-HSBC-Src-Device-Id': '',
                        'X-HSBC-Session-Correlation-Id': '',
                        'X-HSBC-Src-UserAgent': '',
                        'X-HSBC-Request-Correlation-Id': '',
                        'X-HSBC-IP-Id': '',
                        'X-HSBC-client-id': constants.clientId || '573457ec21bd4f209a5585e041bcf3a9',
                        'X-HSBC-client-secret': constants.secretId || 'fed4e2cb4775418d80C098E4824EC69D',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET,PUT,POST',
                        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept,Access-Control-Expose-Headers,Authorization',
                    }


                });
            }
        if( request.url.indexOf('.json') === -1 && this._authservice.authToken ){
                request = request.clone({
                    setHeaders:{
                        'Authorization' : this._authservice.authToken
                    }
                }) 
        }           
        return next.handle(request).do((ev: any) => {
            if( ev instanceof HttpResponse){ 
                if((request.url.indexOf("/arn") > -1) || (request.url.indexOf("/retrieveToken") > -1 )){
                    this._authservice.authToken = ev.body.Authorization;
                }
                else if (ev.headers.get('Authorization')){
                    this._authservice.authToken = ev.headers.get('Authorization');
                }

            }

        })

            .catch(response => {
               
                if (request.url.indexOf('customer-id-search') > -1 || request.url.indexOf('validate-emirates-cn1') > -1 ){
                    if (response instanceof HttpErrorResponse) {
                        
                      return Observable.throw(response);
                    // alert(response.error['message']);
                    }

                    return;
                }
                if (request.url.indexOf('refreshSession') > -1) {
                    if (response instanceof HttpErrorResponse) {
                       
                        if (this.unauthStatuses.indexOf(response.status) > -1) {
                            this.clearStorage();

                            this.zone.run(() => { this.router.navigate(['errMsg']); });
                        }


                    }

                    return;
                }

                
                Helper.enableSpinner(false);
                if ((request.url.indexOf('docUpload') == -1) &&
                    (request.url.indexOf('deleteDoc') == -1) &&
                    (request.url.indexOf('application') == -1) &&
                    request.url.indexOf('refreshSession') == -1) {
                        this.zone.run(()=>{
                             Helper.applicationObj.errorMsg = constants.TECHNICAL_ERROR_MSG;        
                            this.router.navigate(['error']);
                        });

                };
                return response;
            })
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/services/http-interceptor.service.ts